import request from "../utils/request";

export function createGiftsHospitalityDeclaration(data) {
  return request({
    url: "/gifts-hospitality",
    method: "post",
    data,
  });
}

export function getMyGiftsHospitalityDeclarations(query = {}) {
  return request({
    url: "/gifts-hospitality/my",
    method: "get",
    params: {
      page: query.page != null ? query.page : 1,
      size: query.size != null ? query.size : 15,
      sortBy: query.sortBy || "createdAt",
      sortDesc: query.sortDesc != null ? query.sortDesc : true,
      status: query.status || undefined,
      protocol: query.protocol || undefined,
    },
  });
}

export function getGiftsHospitalityDeclarations(query = {}) {
  return request({
    url: "/gifts-hospitality",
    method: "get",
    params: {
      page: query.page != null ? query.page : 1,
      size: query.size != null ? query.size : 15,
      sortBy: query.sortBy || "createdAt",
      sortDesc: query.sortDesc != null ? query.sortDesc : true,
      status: query.status || undefined,
      protocol: query.protocol || undefined,
      company: query.company || undefined,
    },
  });
}

export function getGiftsHospitalityDeclaration(id) {
  return request({
    url: `/gifts-hospitality/${id}`,
    method: "get",
  });
}

export function approveGiftsHospitalityDeclaration(id, data = {}) {
  return request({
    url: `/gifts-hospitality/${id}/approve`,
    method: "patch",
    data,
  });
}

export function rejectGiftsHospitalityDeclaration(id, data = {}) {
  return request({
    url: `/gifts-hospitality/${id}/reject`,
    method: "patch",
    data,
  });
}

export function giftsHospitalityFileDownloadUrl(declarationId, fileId) {
  return `/api/gifts-hospitality/${declarationId}/files/${fileId}`;
}
